import { render, staticRenderFns } from "./SystemTagManagement.vue?vue&type=template&id=06eacf02"
import script from "./SystemTagManagement.vue?vue&type=script&lang=js"
export * from "./SystemTagManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports